import { render, staticRenderFns } from "./vue-pdf.vue?vue&type=template&id=3e085800&scoped=true&"
import script from "./vue-pdf.vue?vue&type=script&lang=js&"
export * from "./vue-pdf.vue?vue&type=script&lang=js&"
import style0 from "./vue-pdf.vue?vue&type=style&index=0&id=3e085800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e085800",
  null
  
)

export default component.exports